module.exports = __webpack_public_path__ + "img/moonlamp.a1170dc7.png";